import axios from "axios";
import { DonationURL } from "../../../../config/UrlEndPoint";

export const URL = `${DonationURL}thk_distribution`;

// Get DistributionNormal All For use Combobox data
export function getDistributionNormalAll(params) {
  return axios.post(URL, params);
}

// items => filtered/sorted result for table data
export function findDistributionNormal(queryParams) {
  return axios.post(`${URL}/list`, queryParams);
}

export function submitDistribution(queryParams) {
  return axios.post(`${URL}/submit`, queryParams);
}
